import * as React from "react"
import { Flex, Text } from "@chakra-ui/react"
import { Icon } from "../../common/icons"
import { HiArrowSmRight } from "react-icons/hi"
/* import { ChatMessageText } from "./_chatMessageText" */
import { TargetUser } from "../../../recoil/atoms/chats/types"
import { ChatStyles } from "./index"

interface ChatUserNameProps {
  author: {
    id: string
    name: string
    photo?: string
    avatar?: string
  }
  isTransparent: boolean
  isModerator?: boolean
  isPrivateMessage?: boolean
  hovered: boolean
  message?: string
  localUserName: string
  localUserId: string | number
  targetUser: TargetUser
  styleschat: ChatStyles
  isMobile: boolean
}

const _ChatUserName: React.FC<ChatUserNameProps> = ({
  author,
  isTransparent,
  isModerator,
  isPrivateMessage,
  hovered,
  message,
  localUserName,
  localUserId,
  targetUser,
  styleschat,
  isMobile
}) => {
  const textMessage = React.useMemo(() => {
    return isPrivateMessage
      ? author?.id === localUserId
        ? localUserName
        : author?.name
      : author?.name
  }, [author?.id, author?.name, isPrivateMessage, localUserId, localUserName])

  const isPrivateMessageModerator = React.useMemo(() => {
    return (
      isModerator &&
      isPrivateMessage &&
      targetUser &&
      Object.entries(targetUser)?.length !== 0
    )
  }, [isModerator, isPrivateMessage, targetUser])

  return (
    <Flex flexDirection="row">
      {isTransparent ? (
        <>
          <Flex
            visibility={hovered ? "hidden" : "unset"}
            // flexDirection="column"
          >
            <Text
              fontSize={isMobile ? "0.85rem" : "0.75rem"}
              fontWeight={"600"}
              lineHeight={1}
              color={
                isTransparent
                  ? "white"
                  : styleschat?.servicePanelElementPrimaryText ?? "#718096"
              }
            >
              {textMessage}
            </Text>
            {/* <ChatMessageText
              isMobile={isMobile}
              styleschat={styleschat}
              hovered={hovered && isModerator && !isPrivateMessage}
              message={message}
              isTransparent={isTransparent}
            /> */}
          </Flex>
          {isModerator &&
            isPrivateMessage &&
            targetUser &&
            Object.entries(targetUser)?.length !== 0 && (
              <Flex>
                <Icon
                  src={HiArrowSmRight}
                  marginTop="-0.5"
                  color={
                    styleschat?.servicePanelElementSecondaryText ?? "#718096"
                  }
                />
                <Text
                  fontSize={isMobile ? "0.85rem" : "0.75rem"}
                  fontWeight={"600"}
                  lineHeight={1}
                  color={
                    isTransparent
                      ? "white"
                      : styleschat?.servicePanelElementPrimaryText ?? "#718096"
                  }
                >
                  {author.id !== localUserId ? localUserName : targetUser.name}
                </Text>
              </Flex>
            )}
        </>
      ) : (
        <>
          <Flex
            opacity={hovered ? "0.2" : "1"}
            marginBottom={isMobile ? "0px" : "0.4rem"}
          >
            <Text
              fontSize={isMobile ? "0.85rem" : "0.75rem"}
              fontWeight={"600"}
              color={
                isTransparent
                  ? "white"
                  : styleschat?.servicePanelElementPrimaryText ?? "#718096"
              }
            >
              {textMessage}
            </Text>
          </Flex>
          {isPrivateMessageModerator && (
            <Flex>
              <Icon
                src={HiArrowSmRight}
                marginTop="1.5px"
                color={
                  isTransparent
                    ? "white"
                    : styleschat?.servicePanelElementSecondaryText ?? "#718096"
                }
              />
              <Text
                fontSize={isMobile ? "0.85rem" : "0.75rem"}
                fontWeight={"600"}
                color={
                  isTransparent
                    ? "white"
                    : styleschat?.servicePanelElementSecondaryText ?? "#718096"
                }
              >
                {author.id !== localUserId ? localUserName : targetUser.name}
              </Text>
            </Flex>
          )}
        </>
      )}
    </Flex>
  )
}

export const ChatUserName = React.memo(_ChatUserName)
